module.exports = __webpack_public_path__ + "img/developer-icon.d2f83e48.svg";